import React, {useEffect, useState} from "react";
import Switch from "react-bootstrap-switch";
import ReactJson from "react-json-view";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { useForm } from "react-hook-form";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";



// components
import {
    ButtonCancel, CustomMiniButtonX,
} from "../../../components/buttons/buttonsActions";

// labels
import { FORM } from "../../../components/i18n/i18n";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import {TT_CLOSE} from "../../../components/i18n/toolTips";
import TraceDetail from "./_traceDetail";
import {utilHelper} from "../../../jwt/_helpers";
import {getStateByPath} from "../../../redux/selectors";

// components

// services & providers

const AppRequestLogForm = props => {

    // const { domainObject } = props.formProps;
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { domainObject } = componentState?.data;



    const [request, setRequest] = useState("{}");
    const [response, setResponse] = useState("{}");

    const [center] = useState(props.center || { lat: 20.581465, lng: -87.120603 });

    // const [method] = useState( domainObject?.method );

    const [showDetailedJson, setShowDetailedJson] = useState(false);

    useEffect(() => {
        try {
            setRequest(JSON.parse(domainObject?.request));
        } catch (ignored) {
            const something = JSON.parse('{ "request":"' + domainObject?.request + '"}')
            setRequest(something);
        }
        try {
            setResponse(JSON.parse(domainObject?.response));
        } catch (ignored) {
            try {
                const something = JSON.parse('{ "response":"' + domainObject?.response + '"}')
                setResponse(something);
            } catch (ex) {
                console.log(ex);
                setResponse("");
            }
        }
    }, []);

    const validationSchema = Yup.object().shape({
    });

    const {register, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            request: domainObject?.request,
            response: domainObject?.response,
            registerDate: utilHelper.datetimeFormatter(domainObject?.registerDate) ,
            app: domainObject?.app,
            method: domainObject?.method,
            activityName: domainObject?.activityName,
            deviceId: domainObject?.deviceId,
            visitorId: domainObject?.visitorId,
        }
    });

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path);
        props.onClose(path);
    }

    return (<>
            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-edit mr-2"/>
                    {FORM}
                    <div className="float-right">
                        <CustomMiniButtonX
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>

                <CardBody className={'card-body-modal'}>
                    <Form >
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Aplicación</Label>
                                    <Input type="text"
                                           name="app"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Actividad</Label>
                                    <Input type="text"
                                           name="activityName"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Fecha de registro</Label>
                                    <Input type="text"
                                           name="registerDate"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="8">
                                <FormGroup>
                                    <Label>{"Id Dispositivo"}</Label>
                                    <Input type="text"
                                           name="deviceId"
                                           innerRef={register}
                                           disabled={true}/>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label >Ver como :</Label><br/>
                                    <Switch animate={true} offText={"Cadena"} onText={"JSON"}
                                            innerRef={register}
                                            onChange={_ => setShowDetailedJson(!showDetailedJson)}
                                            value={showDetailedJson}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        {
                            domainObject?.method === 'Trace.CalculatePath' &&
                            <Row >
                                <Col md="12">
                                    <TraceDetail
                                        udn={{code:'xc'}}
                                        routAB={response?.response}
                                        pointA={request?.body?.pointA}
                                        pointB={request?.body?.pointB}
                                        googleConfig={{ mapOptions : { center : center }}} // solo necesita googleConfig?.mapOptions.center;
                                    />
                                </Col>
                            </Row>
                        }
                        {
                            showDetailedJson ?
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Solicitud (JSON)</Label>
                                            <ReactJson src={request} name={'request'} displayDataTypes={false} collapsed={true}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Respuesta (JSON)</Label>
                                            <ReactJson src={response} name={'response'} displayDataTypes={false}/>
                                        </FormGroup>
                                    </Col>
                                </Row> :
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Solicitud (JSON)</Label>
                                            <Input type="textarea" name="request"
                                                   rows="20"
                                                   innerRef={register}
                                                   disabled={true}/>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Respuesta (JSON)</Label>
                                            <Input type="textarea" name="response"
                                                   rows="20"
                                                   innerRef={register}
                                                   disabled={true}/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                        }
                        <CardBody className="border-top">
                            <div className="float-right">
                                <ButtonCancel onClick={closeForm}/>
                            </div>
                        </CardBody>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}


const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(AppRequestLogForm)